import { useQueryClient } from 'react-query';
import { useCallback } from 'react';
import { CacheKeys } from '../constants';
import { MessageType } from '../types';
export const useLocalAppointmentUpdate = () => {
    const queryClient = useQueryClient();
    const mutate = useCallback((data) => {
        const queries = queryClient.getQueriesData(CacheKeys.APPOINTMENTS);
        for (const query of queries) {
            const key = query[0];
            queryClient.setQueryData(key, (prev) => {
                if (!prev)
                    return undefined;
                const nextPagesArray = prev.pages.map((page) => ({
                    records: page.records.map((appt) => appt.id === data.id ? data : appt),
                    meta: page.meta
                }));
                return {
                    pages: nextPagesArray,
                    pageParams: prev.pageParams
                };
            });
        }
        queryClient.setQueryData([CacheKeys.APPOINTMENT, data.id], (prev) => {
            if (!prev)
                return undefined;
            return data;
        });
        const conversationQueries = queryClient.getQueriesData([
            CacheKeys.MESSAGES,
            data.thread
        ]);
        for (const query of conversationQueries) {
            const key = query[0];
            queryClient.setQueryData(key, (prev) => {
                if (!prev)
                    return undefined;
                const nextPagesArray = prev.pages.map((page) => ({
                    records: page.records.map((message) => message.type === MessageType.Appointment &&
                        message.data.id === data.id
                        ? Object.assign(Object.assign({}, message), { data: {
                                time: data.time,
                                duration: data.duration,
                                subject: data.subject,
                                status: data.status,
                                participants: data.participants.map(({ id, status }) => ({
                                    id,
                                    status
                                }))
                            } }) : message),
                    meta: page.meta
                }));
                return {
                    pages: nextPagesArray,
                    pageParams: prev.pageParams
                };
            });
        }
    }, []);
    return { mutate };
};
//# sourceMappingURL=useLocalAppointmentUpdate.js.map